import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FileInput from '../../../components/fields/FileInput/FileInput';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';

export default function ImportDialog({ onClose, handleImport, showSelector = false }) {
  const [file, setFile] = useState(null);
  const { control } = useForm({ defaultValues: {} });

  return (
    <Dialog
      onClose={onClose}
      size="none"
      open
    >
      <DialogTitle
        header="Импорт зон"
        title={<Icons width={14} height={14} customIcon icon="clear" className="pointer" onClick={onClose} />}
      />
      <DialogContent>
        <div className="f4">Выберите файл для импорта</div>
        <div className="mt-3">
          <FileInput
            type="text"
            component={FileInput}
            variant="material"
            label="Выберите файл для импорта"
            inputProps={{
              onChange: setFile,
            }}
          />
        </div>
      </DialogContent>
      <DialogFooter>
        <Button variant="secondary" onClick={onClose}>Отменить</Button>
        <Button onClick={() => {
          onClose();
          handleImport(file);
        }}
        >Импортировать
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
